const BYTES_PER_MB = 1024 * 1024;

/** Human-readable megabyte label for upload helper and error copy (binary MB). */
export function formatMaxUploadSize(bytes: number): string {
  const mb = bytes / BYTES_PER_MB;
  if (Number.isInteger(mb)) {
    return `${mb} MB`;
  }

  const rounded = Math.round(mb * 10) / 10;
  return `${rounded} MB`;
}
